import { ROUTES } from "@/config/routes";
import { usePermissions } from "@/hooks/usePermissions";
import { Badge, Box, Button, Card, Heading, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { formatCop } from "../format";
import { useInductionSummary } from "../useInductionSummary";

const InductionCallout = (): JSX.Element | null => {
  const { summary } = useInductionSummary();
  const { isEditor } = usePermissions();
  const navigate = useNavigate();

  if (!summary || summary.availableCount === 0) return null;

  const { availableCount, referenceSaving } = summary;

  return (
    <Card.Root
      borderRadius="lg"
      border="none"
      flexShrink={0}
      boxShadow="rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px"
    >
      <Card.Body
        p="4"
        display="grid"
        gridTemplateColumns={{ base: "1fr", md: "1.3fr 1fr" }}
        alignItems="stretch"
        gap="4"
      >
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          gap="2"
        >
          <Badge
            alignSelf="flex-start"
            bg="palomma.100"
            color="palomma.500"
            size="md"
          >
            {availableCount} pre-aprobado{availableCount === 1 ? "" : "s"}
          </Badge>
          <Heading size="lg">
            Ahorra en tus fianzas con inducción a Fianza Palomma
          </Heading>
          <Text color="gray.600">
            Te garantizamos la tasa más competitiva del mercado
          </Text>
          {isEditor && (
            <Button
              alignSelf="flex-start"
              onClick={() => navigate(ROUTES.DASHBOARD.PROTECT_INDUCTION)}
            >
              Descubre cuánto puedes ahorrar
            </Button>
          )}
        </Box>
        {referenceSaving > 0 && (
          <Box
            bg="gray.50"
            borderRadius="md"
            p="5"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            gap="1"
          >
            <Text fontWeight="semibold" color="gray.600">
              Ahorro aproximado
            </Text>
            <Heading size="4xl" color="green.700">
              {formatCop(referenceSaving * 12)} al año*
            </Heading>
            <Text fontWeight="semibold" color="gray.600" fontSize="sm">
              *Estimado anual: compara la tasa que te ofrece Palomma en tus
              pre-aprobados con la tasa de mercado de tu sucursal.
            </Text>
          </Box>
        )}
      </Card.Body>
    </Card.Root>
  );
};

export default InductionCallout;
